import { styled } from "solid-styled-components";

export const InfiniteFeedWrapper = styled.div<{ isReverse?: boolean }>`
  height: 100%;
  width: 100%;
  overflow: auto;
  ${({ isReverse }) => (isReverse ? "transform: scaleY(-1);" : "")}
  & > div {
    width: 100%;
    position: relative;
    & > div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }

  ${({ isReverse }) =>
		isReverse
			? `.virtualizerItem {
    transform: scaleY(-1);
  }`
			: ""}
`;
